import React, { useState } from "react";
import AdminLogin from "./AdminLogin/AdminLogin";
import AdminTwoFactor from "./AdminTwoFactor/AdminTwoFactor";
import AdminSelectApplication from "./AdminSelectApplication/AdminSelectApplication";

function AdminAuth({ onAuthenticated }) {
  const [step, setStep] = useState("login"); // 'login', 'twofactor', 'select'
  const [loginData, setLoginData] = useState(null);
  const [adminToken, setAdminToken] = useState(null);

  const handleLoginSuccess = (data) => {
    setLoginData(data);
    setStep("twofactor");
  };

  const handleTwoFactorSuccess = (token) => {
    setAdminToken(token);
    setStep("select");
  };

  const handleMasqueradeSuccess = (token) => {
    localStorage.setItem("JWT", token);
    // Pass the admin token for switch user functionality
    onAuthenticated(token, adminToken);
  };

  const handleBackToLogin = () => {
    setStep("login");
    setLoginData(null);
    setAdminToken(null);
  };

  const handleBackToTwoFactor = () => {
    setStep("twofactor");
    setAdminToken(null);
  };

  if (step === "twofactor" && loginData) {
    return (
      <AdminTwoFactor
        loginData={loginData}
        onSuccess={handleTwoFactorSuccess}
        onBack={handleBackToLogin}
      />
    );
  }

  if (step === "select" && adminToken) {
    return (
      <AdminSelectApplication
        adminToken={adminToken}
        onSuccess={handleMasqueradeSuccess}
        onBack={handleBackToTwoFactor}
        onLogout={handleBackToLogin}
      />
    );
  }

  return <AdminLogin onSuccess={handleLoginSuccess} />;
}

export default AdminAuth;

